<template>
  <div class="more-page common-bg" >
    <van-nav-bar fixed title="更多" left-text="" left-arrow @click-left="onClickLeft" />
    <div style="height: 30px"></div>
    <div class="more-box">
        <van-row gutter="20">
            <van-col span="12" v-for="(item, index) in gameList" :key="index">
                <div class="game-item">
                    <div class="title">
                        <div class="cn">{{item.name}}</div>
                        <div class="en">{{item.el}}</div>
                    </div>
                    <div class="img-container">
                        <van-image  width="3.6rem" height="2.45rem" fit="contain" :src="item.img"/>
                    </div>
                </div>
            </van-col>
        </van-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'gameMore',
  data () {
    return {
        gameList: [
            {name: '区块链', el: 'BLOCKCHAIN', img: '/static/newImg/game/img_qkl.avif'},
            // {name: '捕鱼', el: 'FISHING', img: '/static/newImg/game/img_syyx2_2.avif'},
            {name: '电竞', el: 'E-SPORTS', img: '/static/newImg/game/img_dj.avif'},
            {name: '热门', el: 'HOT', img: '/static/newImg/game/img_hot.avif'},
            {name: '试玩', el: 'DEMO', img: '/static/newImg/game/img_sw.avif'},
            {name: '最近', el: 'RECENT', img: '/static/newImg/game/img_zj.avif'},
            {name: '收藏', el: 'FAVORITES', img: '/static/newImg/game/img_sc.avif'},
        ]
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
  created () {
    // this.$router.push('/game')
  }
}
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';
.more-page{min-height: 100vh;}
.more-box {
    padding: 20px;
    box-sizing: border-box;
}

.game-item {position: relative;
    height: 2.48rem;margin-top: .21rem;color:#fff;border-radius: .2rem;background: #292A2C;border: .014rem solid #3B3C3D;
    .title{position: absolute;top: .2rem;left: .2rem;border-left: .024rem solid #DFB372;padding-left: .15rem;
        .cn {
            font-size: 0.25rem;
            font-weight: bold;
        }
        .en {
            font-size: 0.18rem;
        }
    }
    .img-container{position: absolute;top: 0;right: 0;bottom: -5px;}
}
</style>


// WEBPACK FOOTER //
// src/components/gameMore.vue